import { cn } from '@aibi/ui';
import { Calendar, Fingerprint, Globe, Sigma, Type, type LucideIcon } from 'lucide-react';
import type { FieldRole } from '../../model/field-catalog';

const ICONS: Readonly<Record<FieldRole, LucideIcon>> = {
  categorical: Type,
  temporal: Calendar,
  geographic: Globe,
  identifier: Fingerprint,
  measure: Sigma,
};

/** Icono por rol del campo: dimensiones en tono neutro, medidas en tono primario. */
export function FieldIcon({
  role,
  className,
}: {
  readonly role: FieldRole;
  readonly className?: string;
}) {
  const Icon = ICONS[role];
  return (
    <Icon
      aria-hidden
      className={cn(
        'size-3.5 shrink-0',
        role === 'measure' ? 'text-primary' : 'text-muted-foreground',
        className,
      )}
    />
  );
}
